/**
 * <mega-menu-hover-products>
 *
 * Wraps a single mega-menu grid (`.mega-menu__grid`). The featured-products area
 * pre-renders one product list per child collection (`[data-megamenu-panel="<handle>"]`,
 * hidden) plus the parent default (`[data-megamenu-panel="__default__"]`, visible).
 * Hovering a child column (`[data-megamenu-hover="<handle>"]`) reveals that child's
 * panel; leaving the grid restores the default. No network calls — everything is
 * server-rendered, this only toggles visibility.
 *
 * Uses event delegation + a live panel query on hover (rather than caching nodes in
 * connectedCallback) because Horizon injects the mega-menu products LATE via section
 * hydration — the element connects before the panels exist, so anything captured at
 * connect time would be stale.
 */
if (!customElements.get('mega-menu-hover-products')) {
  customElements.define(
    'mega-menu-hover-products',
    class MegaMenuHoverProducts extends HTMLElement {
      #DEFAULT = '__default__';
      #lastKey = null;

      connectedCallback() {
        this.addEventListener('pointerover', this.#onOver);
        this.addEventListener('pointerleave', this.#onLeave);
      }

      disconnectedCallback() {
        this.removeEventListener('pointerover', this.#onOver);
        this.removeEventListener('pointerleave', this.#onLeave);
      }

      #onOver = (event) => {
        const trigger = event.target.closest?.('[data-megamenu-hover]');
        if (!trigger || !this.contains(trigger)) return;
        this.#show(trigger.getAttribute('data-megamenu-hover'));
      };

      #onLeave = () => this.#show(this.#DEFAULT);

      #show(key) {
        if (key === this.#lastKey) return;
        const panels = this.querySelectorAll('[data-megamenu-panel]');
        if (panels.length < 2) return; // child panels not injected yet / none — nothing to swap
        const keys = Array.from(panels, (panel) => panel.getAttribute('data-megamenu-panel'));
        const target = keys.includes(key) ? key : this.#DEFAULT;
        this.#lastKey = target;
        panels.forEach((panel) => {
          panel.hidden = panel.getAttribute('data-megamenu-panel') !== target;
        });
      }
    }
  );
}
